import api from './api';

export const adminAPI = {
  // Dashboard
  getDashboard: () => api.get('/admin/dashboard'),
  
  // Companies
  getCompanies: () => api.get('/admin/companies'),
  getCompany: (id) => api.get(`/admin/companies/${id}`),
  createCompany: (data) => api.post('/admin/companies', data),
  updateCompany: (id, data) => api.put(`/admin/companies/${id}`, data),
  deleteCompany: (id) => api.delete(`/admin/companies/${id}`),
  
  // Logo Upload
  uploadLogo: (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    return api.post('/admin/upload-logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  // Meetings
  getAllMeetings: () => api.get('/admin/meetings'),
  exportMeetingsToExcel: () => api.get('/admin/meetings/export', { responseType: 'blob' }),
  
  // Events
  getEvents: () => api.get('/admin/events'),
  createEvent: (data) => api.post('/admin/events', data),
  updateEvent: (id, data) => api.put(`/admin/events/${id}`, data),
  deleteEvent: (id) => api.delete(`/admin/events/${id}`),
  getEvent: (id) => api.get(`/admin/events/${id}`),
  
  // Buyers
  getBuyers: () => api.get('/admin/buyers'),
  createBuyer: (data) => api.post('/admin/buyers', data),
  updateBuyer: (id, data) => api.put(`/admin/buyers/${id}`, data),
  deleteBuyer: (id) => api.delete(`/admin/buyers/${id}`),
  
  // Password
  changePassword: (data) => api.post('/admin/change-password', data),
  
  // Company Admin Password Management
  getCompanyPasswords: () => api.get('/admin/company-passwords'),
  resetCompanyPassword: (companyId, newPassword) => api.post(`/admin/companies/${companyId}/reset-password`, { new_password: newPassword }),
  generateRandomPassword: (companyId) => api.post(`/admin/companies/${companyId}/generate-password`),
  
  // Buyer Password Management
  generateRandomBuyerPassword: (buyerId) => api.post(`/admin/buyers/${buyerId}/generate-password`),
  resetBuyerPassword: (buyerId, newPassword) => api.post(`/admin/buyers/${buyerId}/reset-password`, { new_password: newPassword }),
  
  // User Management
  getUsers: () => api.get('/admin/users'),
  convertUserToBuyer: (userId, data) => api.post(`/admin/users/${userId}/convert-to-buyer`, data),
};

export const companyAdminAPI = {
  // Meetings
  getCompanyMeetings: () => api.get('/company-admin/meetings'),
  updateMeetingStatus: (meetingId, status) => api.patch(`/company-admin/meetings/${meetingId}/status`, { status }),
  cancelMeeting: (meetingId) => api.post(`/company-admin/meetings/${meetingId}/cancel`),
  rescheduleMeeting: (meetingId, newSlotId) => api.post(`/company-admin/meetings/${meetingId}/reschedule`, { new_slot_id: newSlotId }),
  exportMeetingsToExcel: () => api.get('/company-admin/meetings/export', { responseType: 'blob' }),
  
  // Slots
  getCompanySlots: () => api.get('/company-admin/slots'),
  toggleSlotAvailability: (slotId, isAvailable) => api.post(`/company-admin/slots/${slotId}/toggle`, { is_available: isAvailable }),
  
  // Company
  getCompanyInfo: () => api.get('/company-admin/company'),
  updateCompanyDescription: (data) => api.put('/company-admin/company-description', data),
  
  // Buyers
  getBuyers: () => api.get('/company-admin/buyers'),
  getBuyerSlots: (buyerId) => api.get(`/company-admin/buyers/${buyerId}/slots`),
  requestMeetingFromBuyer: (buyerId, meetingSlotId) => api.post('/company-admin/buyers/request-meeting', { buyer_id: buyerId, meeting_slot_id: meetingSlotId }),
  
  // Password
  changePassword: (data) => api.post('/company-admin/change-password', data),
};

export const buyerAdminAPI = {
  // Meetings
  getBuyerMeetings: () => api.get('/buyer-admin/meetings'),
  updateMeetingStatus: (meetingId, status) => api.patch(`/buyer-admin/meetings/${meetingId}/status`, { status }),
  cancelMeeting: (meetingId) => api.post(`/buyer-admin/meetings/${meetingId}/cancel`),
  exportMeetingsToExcel: () => api.get('/buyer-admin/meetings/export', { responseType: 'blob' }),
  
  // Slots
  getBuyerSlots: () => api.get('/buyer-admin/slots'),
  toggleSlotAvailability: (slotId, isAvailable) => api.post(`/buyer-admin/slots/${slotId}/toggle`, { is_available: isAvailable }),
  
  // Password
  changePassword: (data) => api.post('/buyer-admin/change-password', data),
};
